/**
 * Copyright © 2018 Emu Analytics
 */

import { Client } from './client';
import { BaseEndpoints } from './base.endpoints';
import { IJob, IJobSubmission, IJobStatus } from './api-interfaces';

export class JobEndpoints extends BaseEndpoints<IJob> {
  constructor(client: Client) {
    super(client, 'jobs');
  }

  submit(submission: IJobSubmission): Promise<IJob> {
    return this.client._post(`/api/v1/jobs/submit`, submission);
  }

  getStatus(jobId: string): Promise<IJobStatus> {
    return this.client._get(`/api/v1/jobs/${jobId}/status`);
  }

  setStatus(jobId: string, status: IJobStatus): Promise<IJob> {
    return this.client._post(`/api/v1/jobs/${jobId}/status`, status);
  }

  cancel(jobId: string): Promise<IJob> {
    return this.client._post(`/api/v1/jobs/${jobId}/cancel`, {});
  }

  request(jobType: string): Promise<IJob> {
    return this.client._post(`/api/v1/jobs/request`, { type: jobType });
  }
}
